import React, { useEffect, useState, } from "react";
import { Card, CardBody, CardHeader, Col, Container, FormGroup, Label, Row, Button } from "reactstrap";
import Select from "react-select";
import { MetaTags } from "react-meta-tags";
import { getPartyListAPI } from "../../../store/Administrator/PartyRedux/action";
import { useDispatch, useSelector } from "react-redux";
import {
    saveCopyRoleAccessAction,
} from "../../../store/actions";
import { useHistory } from "react-router-dom";
import { getcompanyList } from "../../../store/Administrator/CompanyRedux/actions";
import { getRole } from "../../../store/Administrator/RoleMasterRedux/action";
import { btnIsDissablefunc, isSuperAdmin } from "../../../components/Common/CommonFunction";
import { C_Button } from "../../../components/Common/CommonButton";

const RoleAccessCopyFunctionality = (props) => {

    const [copyRole_Dropdown_Select, setCopyRole_Dropdown_Select] = useState("");
    const [copyDivision_dropdown_Select, setCopyDivision_dropdown_Select] = useState("");
    const [newRoleDropdown_Select, setNewRoleDropdown_Select] = useState("");
    const [newDivision_dropdown_Select, setNewDivision_dropdown_Select] = useState(null);
    const [newcompany_dropdown_Select, setNewCompany_dropdown_Select] = useState("");
    const [company_dropdown_Select, setCompany_dropdown_Select] = useState("");


    // const [EditData, setEditData] = useState([]);
    const [pageMode, setPageMode] = useState("edit");
    const dispatch = useDispatch();
    const history = useHistory()

    //Access redux store Data 
    const { Roles_redux = [],
        DivisionTypes_redux,
        company,
        CopyBtnloading
    } = useSelector((state) => ({
        DivisionTypes_redux: state.PartyMasterReducer.partyList,
        Roles_redux: state.RoleMaster_Reducer.roleList,
        company: state.Company.companyList,
        CopyBtnloading: state.RoleAccessReducer.CopyBtnloading,
    }));

    useEffect(() => {

        dispatch(getPartyListAPI());
        dispatch(getcompanyList());

    }, []);

    let editDataGatingFromList = props.state;

    // userAccess useEffect
    useEffect(() => {

        if (!(editDataGatingFromList === undefined)) {
            var C_props = editDataGatingFromList

            var divisionId = C_props.Division_id
            if (divisionId === null) {
                divisionId = 0
            }
            var roleId = C_props.Role_id
            var Company_id = C_props.Company_id

            if (roleId > 0) {
                setCopyRole_Dropdown_Select({ label: C_props.RoleName, value: roleId })
                setCopyDivision_dropdown_Select({ label: C_props.DivisionName, value: divisionId })
                setCompany_dropdown_Select({ label: C_props.CompanyName, value: Company_id })

            }
        }

    }, [history]);

    useEffect(() => {
        if (company.length === 1) {
            setCompany_dropdown_Select({
                value: company[0].id,
                label: company[0].Name
            })
        }
    }, [company])

    const newDivisionTypesOption = DivisionTypes_redux.map((Data) => ({
        value: Data.id,
        label: Data.Name
    }));

    const newRole_DropdownOption = Roles_redux.map((Data) => ({
        value: Data.id,
        label: Data.Name,
        CreatedBy: Data.CreatedBy
    }));

    const CompanyValues = company.map((i) => ({
        value: i.id,
        label: i.Name
    }));

    function newRoleDropDown_onChangeHandler(e) {
        setNewRoleDropdown_Select(e)
    }

    function newDivisionTypes_onChangeHandler(e) {
        setNewDivision_dropdown_Select(e)
    }

    function CompanyDropDown_onChangeHandler(e) {
        
        setNewCompany_dropdown_Select(e)
        dispatch(getRole({ loginCompanyID: e.value }));
    }


    function CopyButton_Handler(event) {
        event.preventDefault();
        const btnId = event.target.id
        btnIsDissablefunc({ btnId, state: true })
        try {
            const jsonBody = JSON.stringify(
                {
                    Role: copyRole_Dropdown_Select.value,
                    Division: copyDivision_dropdown_Select.value,
                    Company: company_dropdown_Select.value,
                    NewRole: newRoleDropdown_Select.value,
                    NewDivision: (newDivision_dropdown_Select) ? newDivision_dropdown_Select.value : 0,
                    NewCompany: newcompany_dropdown_Select.value,
                    CreatedBy: newRoleDropdown_Select.CreatedBy,
                    CopyFromSuperAdmin: isSuperAdmin()
                })
            dispatch(saveCopyRoleAccessAction({ jsonBody, btnId }))

        } catch (error) { btnIsDissablefunc({ btnId, state: false }) }
    }

    // IsEditMode_Css is use of module Edit_mode (reduce page-content marging)
    let IsEditMode_Css = ''
    if (pageMode === "edit" || pageMode === "other") { IsEditMode_Css = "-5.5%" };

    return (
        <React.Fragment>
            <div className="page-content" >
                <MetaTags>
                    <title>Role Access| FoodERP-React FrontEnd</title>
                </MetaTags>
                <Container fluid>




                    <Card className="section-card">
                        <CardHeader className="section-header text-center">
                            <h5 className="mb-1">Copy Role Access</h5>
                            <small className="text-muted">
                                Copy permissions from one role to another
                            </small>
                        </CardHeader>
                        <CardBody>

                            {/* ================= SOURCE ================= */}
                            <div className="section-wrapper source-section">
                                <div className="section-title source-title">
                                    Copy From (Source)
                                </div>

                                <Row>

                                    <Col md="4">
                                        <div className="field-box">
                                            <Label>Company</Label>
                                            <div className="value-box">
                                                {company_dropdown_Select.label}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="field-box">
                                            <Label>Role</Label>
                                            <div className="value-box">
                                                {copyRole_Dropdown_Select.label}
                                            </div>
                                        </div>
                                    </Col>

                                    {copyDivision_dropdown_Select.value > 0 && (
                                        <Col md="4">
                                            <div className="field-box">
                                                <Label>Division</Label>
                                                <div className="value-box">
                                                    {copyDivision_dropdown_Select.label}
                                                </div>
                                            </div>
                                        </Col>
                                    )}


                                </Row>
                            </div>

                            {/* 🔁 EXCHANGE ICON */}
                            <div className="exchange-icon">
                                ⇄
                            </div>

                            {/* ================= TARGET ================= */}
                            <div className="section-wrapper target-section">
                                <div className="section-title target-title">
                                    Copy To (Target)
                                </div>

                                <Row>
                                    <Col md="4">
                                        <div className="field-box">
                                            <Label>Company</Label>
                                            <Select
                                                value={newcompany_dropdown_Select}
                                                options={CompanyValues}
                                                onChange={CompanyDropDown_onChangeHandler}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="4">
                                        <div className="field-box">
                                            <Label>Role</Label>
                                            <Select
                                                value={newRoleDropdown_Select}
                                                options={newRole_DropdownOption}
                                                onChange={newRoleDropDown_onChangeHandler}
                                            />
                                        </div>
                                    </Col>

                                    {/* <Col md="4">
                                        <div className="field-box">
                                            <Label>Division</Label>
                                            <Select
                                                value={newDivision_dropdown_Select}
                                                options={newDivisionTypesOption}
                                                onChange={newDivisionTypes_onChangeHandler}
                                            />
                                        </div>
                                    </Col> */}


                                </Row>
                            </div>

                            {/* 🔘 BUTTON OUTSIDE */}
                            <div className="copy-btn-wrapper">
                                <Button
                                    loading={CopyBtnloading}
                                    color="primary"
                                    disabled={CopyBtnloading}   // ✅ prevent multiple clicks
                                    onClick={CopyButton_Handler}
                                >
                                    {CopyBtnloading ? "Copying..." : "Copy Role"}
                                </Button>
                            </div>

                        </CardBody>
                    </Card>


                </Container>
            </div>
        </React.Fragment >
    );


};
export default RoleAccessCopyFunctionality
